import React from "react";
import { Row, Col, Container } from "react-bootstrap";

// Self-contained Finance-style shimmer for the Student Gate Pass module.
const css = `
@keyframes gpShimmer { 0% { background-position: -800px 0; } 100% { background-position: 800px 0; } }
.gp-shim { background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 800px 100%; animation: gpShimmer 1.4s infinite linear; border-radius: 6px; }
`;

const S = ({ width = "100%", height = 14, radius = 6, style = {} }) => (
    <div className="gp-shim" style={{ width, height, borderRadius: radius, ...style }} />
);

export const GatePassShimmer = () => (
    <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
        <style>{css}</style>
        <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
                {/* Header */}
                <div style={{ padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9" }}>
                    <S width={38} height={38} radius={10} style={{ flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                        <S width={170} height={15} style={{ marginBottom: 8 }} />
                        <S width={260} height={10} />
                    </div>
                </div>
                {/* Search bar */}
                <div style={{ padding: "18px 24px", borderBottom: "1px solid #f3f4f6" }}>
                    {/* IN / OUT toggle */}
                    <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
                        <S width={110} height={38} radius={9} />
                        <S width={110} height={38} radius={9} />
                    </div>
                    <Row className="g-2 align-items-end">
                        {[0, 1].map((i) => (
                            <Col xl={3} lg={4} md={6} sm={12} key={i} className="mb-2">
                                <S width="50%" height={11} style={{ marginBottom: 7 }} />
                                <S width="100%" height={42} radius={9} />
                            </Col>
                        ))}
                        <Col xl={2} lg={2} md={6} sm={12} className="mb-2">
                            <S width="100%" height={42} radius={9} />
                        </Col>
                    </Row>
                </div>
                {/* Result card placeholder */}
                <div style={{ padding: "24px" }}>
                    <div style={{ background: "#fff", border: "1px solid #eef2f7", borderRadius: 14, padding: 24 }}>
                        <Row>
                            <Col lg={6} md={12} sm={12} className="mb-3">
                                <div style={{ display: "flex", gap: 18 }}>
                                    <S width={130} height={150} radius={12} style={{ flexShrink: 0 }} />
                                    <div style={{ flex: 1, paddingTop: 6 }}>
                                        {[0, 1, 2, 3].map((i) => <S key={i} width={`${80 - i * 8}%`} height={13} style={{ marginBottom: 14 }} />)}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} md={12} sm={12} className="mb-3">
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
                                    <S width={160} height={170} radius={12} />
                                    <S width={150} height={40} radius={9} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Container>
    </div>
);

export default GatePassShimmer;
